import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LoginFormComponent } from '@assist/account-widgets';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'assist-multiview-more',
  imports: [LoginFormComponent, TranslocoPipe],
  templateUrl: './multiview-more.component.html',
  styleUrl: './multiview-more.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiviewMoreComponent {
  qrCodeId = input.required<string>();
  dashboardMultiViewUrl = computed(() => {
    return `/dashboard?multiview=${this.qrCodeId()}`;
  });
  protected readonly translation = translation;
}
